// Hands the store to every component, and turns "the store changed" into "redraw".

import { createContext, use, useSyncExternalStore, type ReactNode } from 'react';
import type { AppStore } from '.';
import type { StoreState } from './base';

const StoreContext = createContext<AppStore | null>(null);

export function StoreProvider({ store, children }: { store: AppStore; children: ReactNode }) {
  return <StoreContext value={store}>{children}</StoreContext>;
}

export function useStore(): AppStore {
  const store = use(StoreContext);
  if (!store) throw new Error('useStore must be used inside <StoreProvider>.');
  return store;
}

/** The current state. The component redraws whenever the store makes a new state object. */
export function useStoreState(): StoreState {
  const store = useStore();
  return useSyncExternalStore(store.subscribe, store.getState);
}
